// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__4VQGo","logOut":"MainHeader_logOut__7AapI"};